export const STATUS_CAPTION = {
    draft        : "Issue to send to brand",
    issued       : "Sent to brand · awaiting acknowledgement",
    acknowledged : "Acknowledged by brand · awaiting approval",
    approved     : "Approved by brand · ready to settle",
    fund_received: "Funds received from brand",
    rejected     : "Rejected by brand",
    settled      : "Settled",
    reverted     : "Reverted"
};

// Ops can recall a note only until the brand approves it.
export const REVERTIBLE_STATUSES = ["issued", "acknowledged"];
